export default "/images/46cbc211ad749b01de67308dce9e5930.avif";